import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import OkCancelModal from '@/shared/components/OkCancelModal';
import Button from '@/shared/components/Button';
import { useIntl } from 'react-intl';
import messages from '../documentMessages';
export const ExtractZipModal = ({ onAccept, onClose }) => {
    const intl = useIntl();
    const [buttonsDisabled, setButtonsDisabled] = useState(false);
    const continueDisabled = async (next) => {
        setButtonsDisabled(true);
        await next();
    };
    const extractAndKeepButton = (_jsx(Button, Object.assign({ onClick: () => continueDisabled(() => onAccept('1')), btnClassName: "btn-inverse", showProgress: true, name: "OkCancelModal-ExtractAndKeep", disabled: buttonsDisabled }, { children: intl.formatMessage(messages.ExtractAndKeep) })));
    return (_jsx(OkCancelModal, Object.assign({ title: intl.formatMessage(messages.ExtractZipTitle), show: true, onClose: () => continueDisabled(onClose), onSave: () => continueDisabled(() => onAccept('2')), disableFullScreen: true, okLabel: intl.formatMessage(messages.ExtractAndDelete), leftButton: extractAndKeepButton, disabled: buttonsDisabled, cancelDisabled: buttonsDisabled }, { children: _jsx("p", { children: intl.formatMessage(messages.ExtractZipMessage) }) })));
};
